import React, { useEffect, useState } from 'react'
import Pagenation from '../../../GlobalComponents/Pagenation'
import { useParams } from 'react-router-dom'
import { getUserFromLocalStorage } from '../../../../../utils/utils'
import axios from 'axios'
import { decryptResponse, encryptRequestBody } from '../../../../../utils/customAxios'

const PrtCommissonInside = () => {
	const [monthPRTCommission, setMonthPRTCommission] = useState([])
	const [page, setPage] = useState(1)
	const [pageSize, setPageSize] = useState(10)
	const [totalPages, setTotalPages] = useState(1)

	const params = useParams()
	const month = params?.month

	useEffect(() => {
		getMonthPRTCommission()
	}, [page, pageSize])

	const getMonthPRTCommission = async () => {
		try {
			const user = getUserFromLocalStorage()
			const headers = {}
			const access_token = user?.access_token
			if (user && access_token) {
				headers.authorization = `Bearer ${access_token}`
			}

			let body = { page, pagesize: pageSize, month }

			if (process.env.REACT_APP_ENV === 'production') {
				const encryptedRequest = encryptRequestBody(
					body,
					process.env.REACT_APP_REQUEST_CRYPTO_HEX_KEY,
					process.env.REACT_APP_REQUEST_CRYPTO_IV_KEY
				)
				body = encryptedRequest
			}

			const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getPerticularMonthPRTCommission`, body, {
				headers: {
					...headers,
					'Content-Type': 'application/json',
				},
			})

			if (process.env.REACT_APP_ENV === 'production' && response.status === 200) {
				if (response.data) {
					const decryptedResponse = decryptResponse(
						response.data,
						process.env.REACT_APP_RESPONSE_CRYPTO_HEX_KEY,
						process.env.REACT_APP_RESPONSE_CRYPTO_IV_KEY
					)
					response.data = decryptedResponse
				}
			}

			if (response.data.status === 1) {
				setMonthPRTCommission(response.data.data)
				const tPages = response.data.total / pageSize
				setTotalPages(tPages < 1 ? 1 : tPages)
			}
		} catch (error) {
			console.error('error', { error })
		}
	}

	const formatDate = (dateString) => {
		return new Date(dateString)
			.toLocaleDateString('en-IN', {
				day: '2-digit',
				month: 'short',
				year: 'numeric',
			})
			.toUpperCase()
			.replace('.', '')
	}

	return (
		<div>
			<div className='main-width'>
				<div className='row d-flex w-auto justify-content-center'>
					<div className='col-lg-12'>
						<div className='card w-95 card-body mt-2 min-vh-100'>
							<h2 className='source-serif-4 text-normal text-dark'>
								<i className='ri-money-rupee-circle-fill class-name mx-md-2 text-success' aria-hidden='true'></i>
								PRT Commission Details
							</h2>
							<div className='row align-items-center mb-2 container-fluid mt-4'>
								<div className='col-lg-6'>
									<div className='d-flex gap-4'>
										<div>
											<div className='input-group input-group-outline'>
												<select
													className='dataTable-selector border-radius-lg'
													value={pageSize}
													onChange={(e) => setPageSize(Number(e.target.value))}
												>
													<option value='10'>10</option>
													<option value='25'>25</option>
													<option value='50'>50</option>
													<option value='75'>75</option>
													<option value='100'>100</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className='card w-100 text-center mx-auto p-2 mt-3 mb-3 bg-gold-light'>
								<div className='table-responsive border-radius-2xl'>
									<table className='table align-items-center mb-0'>
										<thead>
											<tr>
												<th className='text-uppercase text-dark text-md font-weight-bold'>S.NO</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>Date</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>Members</th>
												<th className='text-uppercase text-dark text-md font-weight-bold'>PRT Commission</th>
											</tr>
										</thead>
										<tbody className='bg-white'>
											{monthPRTCommission.map((commission, index) => (
												<tr key={index}>
													<td className='text-dark text-md font-weight-normal'>{(page - 1) * pageSize + index + 1}</td>
													<td className='text-dark text-md font-weight-normal'>{formatDate(commission?.createdAt)}</td>
													<td className='text-dark text-md font-weight-normal'>{commission?.count}</td>
													<td className='text-dark text-md font-weight-normal'>{commission?.prtCommission}</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
							<Pagenation page={page} setPage={setPage} totalPages={totalPages} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PrtCommissonInside
